import React, { useEffect } from 'react';

import { Controller } from 'react-hook-form';

import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import classes from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage.module.scss';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { Select } from 'components/DesignSystem/Select';

interface Props {
    methods?: any;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    className?: string;
    value?: string;
}

export type ProductivityPreDefinedFilter =
    | 'did_over_performed'
    | 'expect_over_performed'
    | 'did_under_performed'
    | 'expect_under_performed'
    | 'activities_completed'
    | 'activities_missed';

export const productivityPreDefinedFilterOptions: ISelectOption<ProductivityPreDefinedFilter>[] = [
    { label: 'Over Performed (Past Actual greater than Past Planned)', value: 'did_over_performed' },
    { label: 'Under Performed (Past Actual less than Past Planned)', value: 'did_under_performed' },
    { label: 'Expected To Over Perform (Future Planned less than Past Actual KPI)', value: 'expect_over_performed' },
    {
        label: 'Expected To Under Perform (Future Planned greater than Past Actual KPI)',
        value: 'expect_under_performed',
    },
    { label: 'Completed Activities', value: 'activities_completed' },
    { label: 'Missed Activities', value: 'activities_missed' },
];

export const ProductivityPreDefinedFilter = ({
    methods,
    name,
    filtersStatusRef,
    handleFilters,
    className,
    value,
}: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }
        if (value) {
            methods?.setValue(name, value);
        }
        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [filtersStatusRef, methods, name, value]);

    const handleChange = (option: ISelectOption<string> | null) => {
        methods?.setValue(name, option ? option.value : null);
        handleFilters && handleFilters();
    };

    const handleValue = (filterValue) => {
        if (!filterValue) {
            return null;
        }
        return productivityPreDefinedFilterOptions.find((item) => item.value === value) || null;
    };

    return (
        <div className={`${classes.selectWrapper} ${className ?? ''}`}>
            <div className={classes.activityCodesSelectWrapper}>
                <Controller
                    render={({ field }) => (
                        <Select<ISelectOption<ProductivityPreDefinedFilter>>
                            {...field}
                            options={productivityPreDefinedFilterOptions}
                            id={'global-filter-component-productivity-pre-defined-filter'}
                            onChange={handleChange}
                            value={handleValue(field.value)}
                            isClearable={true}
                            label={'Quick Answers'}
                        />
                    )}
                    name={name}
                    control={methods?.control}
                />
            </div>
        </div>
    );
};
